import PersonasTabsComponent from "./personas-tabs-component";
import PersonasTabsConfig from "./personas-tabs-config";
import PersonasTabsAdvancedConfig from "./personas-tabs-advanced-config";

export default {
  PersonasTabsComponent,
  PersonasTabsConfig,
  PersonasTabsAdvancedConfig
};
